export const showMessage = () => ({ type: "SHOW_MESSAGE" });
export const hideMessage = () => ({ type: "HIDE_MESSAGE" });
export const showError = () => ({ type: "SHOW_ERROR" });
export const hideError = () => ({ type: "HIDE_ERROR" });
